/*
  Gemstone picker drawer for SC Product Options (fka Bold Product Options)
  Steamline theme / product-wavy-layout
  -----------------------------------------------------------------------
  - Moves the app's rendered options into a slide-out drawer
  - Counts required options filled (x/y) on the button, drawer head and Confirm
  - Swaps the drawer preview + gallery image using a filename convention:
      {prefix}_{option1}_{option2}.{ext}
    prefix = product metafield custom.render_prefix, or the product handle
    ext    = tries jpg, png, jpeg, webp in turn
    empty slot = "null" (also tries "NULL")
  - Writes the resolved image URL to properties[_Custom_Image_URL]
  - Exposes window.ProductCustomisation { isComplete, open, close, refresh }

  Debug: open the console and run  localStorage.pcDebug = 1  then reload.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-product-customisation]');
  if (!root) return;

  var DEBUG = false;
  try { DEBUG = !!localStorage.getItem('pcDebug'); } catch (e) {}
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[gemstones]'].concat([].slice.call(arguments))); }

  var cfg = {
    prefixes:   [root.dataset.handle].filter(Boolean),
    filesBase:  (root.dataset.filesBase || '').replace(/\/?$/, '/'),
    exts:       [],
    emptyTokens: []
  };
  var ext0 = (root.dataset.imageExt || 'jpg').toLowerCase();
  ['jpg', 'png', 'jpeg', 'webp'].forEach(function (e) { if (cfg.exts.indexOf(e) < 0) cfg.exts.push(e); });
  if (cfg.exts.indexOf(ext0) >= 0) cfg.exts.splice(cfg.exts.indexOf(ext0), 1);
  cfg.exts.unshift(ext0);
  var empty0 = root.dataset.emptyToken || 'null';
  cfg.emptyTokens = [empty0];
  if (empty0.toUpperCase() !== empty0) cfg.emptyTokens.push(empty0.toUpperCase());
  if (empty0.toLowerCase() !== empty0) cfg.emptyTokens.push(empty0.toLowerCase());

  var drawer   = root.querySelector('[data-pc-drawer]');
  var body     = root.querySelector('[data-pc-body]');
  var preview  = root.querySelector('[data-pc-preview]');
  var imgInput = root.querySelector('[data-pc-image-input]');
  var counts   = root.querySelectorAll('[data-pc-count]');
  var form     = root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  var atc      = form ? form.querySelector('.wavy-add-to-cart, [type="submit"], [name="add"]') : null;
  var atcText  = atc ? atc.textContent.trim() : '';
  var lastFocus = null;
  var lastKey = '';
  var resolved = {};                 // key -> url that loaded, or false
  var state = { filled: 0, total: 0, done: false };

  if (form && !form.contains(imgInput)) form.appendChild(imgInput);

  log('config', cfg);

  /* ---------- option helpers ---------- */
  function allOptions() {
    return Array.prototype.slice.call(document.querySelectorAll('.bold_options .bold_option'));
  }
  function isRequired(opt) {
    var t = opt.querySelector('.bold_option_title');
    return !!(t && /\*\s*$/.test(t.textContent));
  }
  function isPicker(opt) {
    return opt.classList.contains('bold_option_swatch') || opt.classList.contains('bold_option_radio') || !!opt.querySelector('select');
  }
  function optionValue(opt) {
    var hidden = opt.querySelector('input[type="hidden"][name^="properties["]');
    if (hidden && hidden.value.trim()) return hidden.value.trim();
    var sel = opt.querySelector('.bold_swatch_selected, .bold_option_value_element[aria-checked="true"]');
    if (sel) {
      var inp = sel.querySelector('input[value]');
      if (inp && inp.value) return inp.value.trim();
    }
    var checked = opt.querySelector('input:checked');
    if (checked) return checked.value.trim();
    var select = opt.querySelector('select');
    if (select) return select.value.trim();
    var text = opt.querySelector('input[type="text"], textarea');
    if (text) return text.value.trim();
    return '';
  }
  function slug(v) {
    return v ? v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
  }

  /* ---------- state ---------- */
  function refresh() {
    var opts = allOptions();
    var req  = opts.filter(isRequired);
    state.filled = req.filter(function (o) { return optionValue(o) !== ''; }).length;
    state.total  = req.length;
    state.done   = state.total > 0 && state.filled === state.total;

    Array.prototype.forEach.call(counts, function (c) { c.textContent = state.filled + '/' + state.total; });

    root.classList.toggle('is-complete', state.done);
    root.classList.toggle('is-incomplete', !state.done && state.total > 0);

    if (atc && state.total > 0) {
      atc.classList.toggle('pc-atc-blocked', !state.done);
      if (!state.done) {
        if (!atc.disabled && atc.textContent.trim() !== 'SELECT GEMSTONES') atc.textContent = 'SELECT GEMSTONES';
      } else if (atc.textContent.trim() === 'SELECT GEMSTONES') {
        atc.textContent = atcText;
      }
    }

    // Summary under the button: tiny swatch + month for each chosen option
    renderSummary(opts.filter(isPicker));

    // Image: use the picker options (swatch / radio / select), required or not
    var imgOpts = opts.filter(isPicker);
    if (!imgOpts.length) imgOpts = req;
    updateImage(imgOpts.map(function (o) { return slug(optionValue(o)); }));
  }

  function swatchImage(opt) {
    var sel = opt.querySelector('.bold_swatch_selected .bold_option_value_swatch > span, .bold_swatch_selected .bold_option_value_swatch');
    if (!sel) return '';
    var bg = sel.style.backgroundImage || getComputedStyle(sel).backgroundImage || '';
    var m = bg.match(/url\(["']?(.*?)["']?\)/);
    return m ? m[1] : '';
  }

  var summaryEl = root.querySelector('[data-pc-summary]');
  function renderSummary(opts) {
    if (!summaryEl) return;
    var chosen = opts.filter(function (o) { return optionValue(o) !== ''; });
    if (!chosen.length) { summaryEl.hidden = true; summaryEl.innerHTML = ''; return; }
    summaryEl.innerHTML = '';
    chosen.forEach(function (o, i) {
      var chip = document.createElement('span');
      chip.className = 'pc-chip';
      var img = swatchImage(o);
      if (img) {
        var thumb = document.createElement('span');
        thumb.className = 'pc-chip__img';
        thumb.style.backgroundImage = 'url("' + img + '")';
        chip.appendChild(thumb);
      }
      chip.appendChild(document.createTextNode(optionValue(o)));
      if (i > 0) summaryEl.appendChild(document.createTextNode(' '));
      summaryEl.appendChild(chip);
    });
    summaryEl.hidden = false;
  }

  function candidates(values) {
    var list = [];
    cfg.prefixes.forEach(function (prefix) {
      cfg.emptyTokens.forEach(function (tok) {
        var parts = values.map(function (v) { return v || tok; });
        cfg.exts.forEach(function (ext) {
          list.push(cfg.filesBase + prefix + '_' + parts.join('_') + '.' + ext);
        });
      });
    });
    return list;
  }

  function updateImage(values) {
    if (!values.some(Boolean)) { imgInput.disabled = true; return; }

    var key = values.join('|');
    if (key === lastKey) return;
    lastKey = key;

    if (resolved[key]) return apply(resolved[key]);
    if (resolved[key] === false) return;

    var list = candidates(values);
    log('trying', list);
    (function tryNext(i) {
      if (i >= list.length) { resolved[key] = false; imgInput.disabled = true; log('no render found for', key); return; }
      var probe = new Image();
      probe.onload  = function () { resolved[key] = list[i]; if (lastKey === key) apply(list[i]); };
      probe.onerror = function () { tryNext(i + 1); };
      probe.src = list[i];
    })(0);
  }

  function apply(url) {
    log('render', url);
    preview.src = url;
    imgInput.value = url;
    imgInput.disabled = false;
    if (window.WavyProduct && window.WavyProduct.setCustomImage) {
      window.WavyProduct.setCustomImage(url);
    } else {
      var main = document.querySelector('[data-main-image], .wavy-main-image');
      if (main) { main.removeAttribute('srcset'); main.src = url; }
    }
  }

  /* ---------- drawer ---------- */
  function open() {
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pc-drawer-open');
    var first = drawer.querySelector('[data-pc-close]');
    if (first) first.focus();
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pc-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.querySelector('[data-pc-open]').addEventListener('click', open);
  Array.prototype.forEach.call(root.querySelectorAll('[data-pc-close]'), function (b) { b.addEventListener('click', close); });
  root.querySelector('[data-pc-confirm]').addEventListener('click', function () {
    if (state.total > 0 && !state.done) {
      // not finished – nudge the first unfilled option into view
      var missing = allOptions().filter(isRequired).filter(function (o) { return optionValue(o) === ''; })[0];
      if (missing) missing.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    // Close and land the customer on the hero image showing their stones,
    // with Add to cart directly beneath. Adding to cart stays a deliberate tap.
    close();
    var hero = document.querySelector('.wavy-main-image-container, [data-main-image]');
    if (hero) setTimeout(function () { hero.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  if (atc) {
    atc.addEventListener('click', function (e) {
      if (root.classList.contains('is-incomplete')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        open();
      }
    }, true);
  }

  window.ProductCustomisation = {
    isComplete: function () { return state.total === 0 || state.done; },
    open: open,
    close: close,
    refresh: refresh
  };

  /* ---------- boot ---------- */
  var refreshTimer = null;
  function scheduleRefresh() {
    // SC updates its inputs asynchronously; check a few times after any interaction
    clearTimeout(refreshTimer);
    refresh();
    setTimeout(refresh, 80);
    setTimeout(refresh, 300);
    refreshTimer = setTimeout(refresh, 900);
  }

  function adopt(el) {
    if (el.dataset.pcAdopted) return;
    el.dataset.pcAdopted = '1';
    Array.prototype.forEach.call(body.querySelectorAll('.bold_options'), function (old) {
      if (old !== el) old.parentNode.removeChild(old);
    });
    body.appendChild(el);
    el.classList.add('pc-options');
    root.hidden = false;
    log('adopted options', el);

    el.addEventListener('click',  scheduleRefresh);
    el.addEventListener('change', scheduleRefresh);
    el.addEventListener('input',  scheduleRefresh);
    new MutationObserver(scheduleRefresh).observe(el, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'class', 'aria-checked'] });

    scheduleRefresh();
  }

  function scan() {
    var strays = document.querySelectorAll('.bold_options:not([data-pc-adopted])');
    Array.prototype.forEach.call(strays, function (el) {
      if (el.querySelector('.bold_option')) adopt(el);
    });
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
